import React, { useState, useEffect } from 'react'
import { Box, Grid } from '@material-ui/core'
import { isEmpty } from 'lodash'

import { Dai, JoditEditor } from 'components'

import useDocumentGenerate from 'hooks/useDocumentGenerate'

import useStyles from './styles'
import * as service from 'service'

const GenerateDocumentStep = () => {
  const {
    documentGenerated,
    documentTemplate,
    documentVariablesFilled,
    handleNext,
    hiddenBackButton,
    resetBackButton,
    setDisabledNextButton,
    setDocumentGenerated,
    wantsToAdvanceStep,
  } = useDocumentGenerate()

  const [displayedContent, setDisplayedContent] = useState('')
  const [alreadyTyped, setAlreadyTyped] = useState(true)
  const [loading, setLoading] = useState(true)

  const classes = useStyles()

  const generateDocument = async () => {
    try {
      setAlreadyTyped(false)
      setLoading(true)
      const response = await service.dponet.documentTemplates.generate({
        documentTemplateId: documentTemplate.id,
        code: documentTemplate?.code,
        documentTemplate: {
          documentVariables: Object.entries(documentVariablesFilled).map(
            ([key, value]) => ({
              id: key.split('-')[1],
              value,
            }),
          ),
        },
      })
      const privacyPolicy = response.data?.privacyPolicy

      setDocumentGenerated(privacyPolicy)
    } catch (error) {
      console.error('Error generating document:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (!documentGenerated?.content) return

    setDisplayedContent('')

    const parser = new DOMParser()
    const doc = parser.parseFromString(documentGenerated.content, 'text/html')
    const elements = Array.from(doc.body.children)

    const typeElements = () => {
      let elementIndex = 0
      let accumulatedHTML = ''

      const addElement = () => {
        if (elementIndex < elements.length && !alreadyTyped) {
          accumulatedHTML += elements[elementIndex].outerHTML
          setDisplayedContent(accumulatedHTML)
          elementIndex++
          setTimeout(addElement, 200)
        } else {
          setAlreadyTyped(true)
        }
      }

      addElement()
    }

    const timer = setTimeout(typeElements, 200)
    return () => clearTimeout(timer)
  }, [documentGenerated?.content])

  useEffect(() => {
    setDisabledNextButton(!alreadyTyped)
  }, [alreadyTyped])

  useEffect(() => {
    if (isEmpty(documentGenerated)) {
      generateDocument()
    } else if (loading) {
      setLoading(false)
    }
  }, [documentGenerated])

  useEffect(() => {
    if (wantsToAdvanceStep) {
      handleNext()
    }
  }, [wantsToAdvanceStep])

  useEffect(() => {
    hiddenBackButton()

    return () => {
      resetBackButton()
    }
  }, [])

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Dai.Card title={documentTemplate?.name || ''} containerPadding={0}>
          <Box className={classes.previewBoxContainer}>
            {loading && (
              <Box p={2}>
                <Dai.Loading loading text="Gerando documento" />
              </Box>
            )}
            <Box padding={2} className={classes.previewBox}>
              {alreadyTyped && !isEmpty(documentGenerated) ? (
                <JoditEditor.Preview
                  allowIframe
                  content={documentGenerated?.content}
                />
              ) : (
                <JoditEditor.Preview allowIframe content={displayedContent} />
              )}
            </Box>
          </Box>
        </Dai.Card>
      </Grid>
    </Grid>
  )
}

export default GenerateDocumentStep
